import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Clickable } from '../common/Button.jsx';
import Defaults from '../layout/Defaults.jsx';
import HeaderText from './HeaderText.jsx';
import { default as _Image, ImageBlockV1, ImageBlockV2 } from '../common/Image.jsx';
import Kit from '../layout/Kit.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import ShowDescription from './ShowDescription.jsx';
import Token from '../common/Token.jsx';

// region IMAGE V1 (-- DEPRECATED Use `ImageV2` --)

function ShowImageV1Component(props) {
    const data = props.data || {};
    return (
        <ImageBlockV1.Component
            blockConfig={props.blockConfig}
            builder={props.builder}
            className="show__img--cont image"
            config={props.config}
            display={data.title}
            image={data.image}
            imageClassName="show__img"
            inLayout={props.inLayout}
            pageType={props.pageType} />
    );
}
const ImageV1 = { Component: ShowImageV1Component };

// region IMAGE V2

function ShowImageV2Component(props) {
    const data = props.data || {};
    return (
        <ImageBlockV2.Component
            {...props}
            alt={data.title}
            className="show__img--cont image"
            image={data.image}
            imageClassName="show__img" />
    );
}
const ImageV2 = { Component: ShowImageV2Component };

// region TITLE V1

function _ShowTitleV1Component(props) {    
    let style = {};
    if (props.blockConfig && props.blockConfig.container) {
        Block.mapStyleConfigProps(style, props.blockConfig.container);
    }
    let className = 'cont--show__title';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className={className} style={layoutStyles.style}>
                    <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const ShowTitleV1Component = Token.withContentTokenParsing(_ShowTitleV1Component, { headerConversionMap: { [Token.Title]: 'h1' } }, (props, keyword, options) => Token.parsing.show({ contentClassNames: { [Token.Title]: 'layout__page__header' }, show: props.data }, keyword, options));
const ShowTitleTokens = () => {
    return [
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Date', Token.Date)
    ];
}
const TitleV1 = { Component: ShowTitleV1Component, Tokens: ShowTitleTokens };

// region TITLE V2 (-- DEPRECATED Use `TitleV1` --)

function ShowTitleV2Component(props) {
    return <HeaderText.TokenizedComponent {...props} defaultDesign={Defaults.Block[Name.Block.Show.TitleV2]} type={Kit.Type.ExhibitionDetail} />
}
const TitleV2 = { Component: ShowTitleV2Component, Tokens: ShowTitleTokens };

// region TOKENIZED

function _ShowMetaTokenizedComponent(props) {
    if (Layout.isFrancisco(props.config)) {
        return <ShowDescription {...props} />
    }
    if (!props.builder && props.content != undefined && props.content.length == 0) {
        return null;
    }
    const [expanded, setExpanded] = React.useState(false);
    const handleToggleExpansion = () => { setExpanded(!expanded) }
    React.useEffect(() => {
        if (!props.builder) {
            return;
        }
        setExpanded(props.blockConfig.block.isExpanded);
    }, [props.blockConfig.block.isExpanded]);

    let buttonDisplayCollapse = 'Show Less';
    let buttonDisplayExpand = 'Read More';
    let showFullText = true;
    let style = {};
    let maxHeight;
    const expandButtonStyle = { display: 'block' };
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            let value;
            for (let propName in props.blockConfig.block) {
                value = props.blockConfig.block[propName];
                switch (propName) {
                    case 'buttonDisplayCollapse':
                        if (value && value.length > 0) {
                            buttonDisplayCollapse = value;
                        }
                        break;
                    case 'buttonDisplayExpand':
                        if (value && value.length > 0) {
                            buttonDisplayExpand = value;
                        }
                        break;
                    case 'isExpanded':
                        showFullText = value;
                        break;
                    case 'maxHeight':
                        if (value && value.value && value.value.length > 0 && value.unit) {
                            maxHeight = `${value.value}${value.unit}`;
                        }
                        break;
                    default:
                        const _propName = propName.replace('Button', '');
                        let _value = value;
                        if (_value && _value.unit) {
                            if (_value.value && _value.value.length > 0) {
                                _value = `${_value.value}${_value.unit}`;
                            } else {
                                _value = undefined;
                            }
                        }
                        expandButtonStyle[_propName] = _value;
                        break;
                }
            }
        }
        if (props.blockConfig.container) {
            Block.mapStyleConfigProps(style, props.blockConfig.container);
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    let className = 'cont--token show__content';
    if (showFullText || expanded) {
        className += ' show__content--show';
        maxHeight = undefined;
    }
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className={!props.inLayout ? "cont--kit__content" : undefined} style={layoutStyles.style}>
                    <div className={className} dangerouslySetInnerHTML={{ __html: props.content }} style={{ height: maxHeight }}></div>
                    {
                        !showFullText &&
                        <span className="show__content--more" style={expandButtonStyle}>
                            <Clickable style={props.builder ? { pointerEvents: 'none' } : undefined} onClick={handleToggleExpansion}>{expanded ? buttonDisplayCollapse : buttonDisplayExpand}</Clickable>
                        </span>
                    }
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const ShowMetaTokenizedComponent = Token.withContentTokenParsing(
    _ShowMetaTokenizedComponent,
    { allowEmptyContent: true, extraParseConditionHandler: (props) => [props.blockConfig.block.isExpanded] },
    (props, keyword, options) => Token.parsing.show({ show: props.data }, keyword, options)
);
const ShowMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Description', Token.Description),
        Token.getWrappedTokenConfig('Date', Token.Date),
        Token.getWrappedTokenConfig('Opening Reception', Token.OpeningReception)
    ];
}
const Tokenized = { Component: ShowMetaTokenizedComponent, Tokens: ShowMetaTokens };

export default {
    ImageV2,
    TitleV1,
    Tokenized,

    // DEPRECATED
    ImageV1,
    TitleV2
}